<div class="heading-title" [ngClass]="">
  <h3 class="title iq-tw-7">{{ title }}</h3>
  <p>{{ subTitle }}</p>
</div>
